import { Component, Vue } from "vue-property-decorator";
@Component
export default class ComponentMixin extends Vue {
  public $cuid!: string;

  public beforeCreate() {
    this.$cuid = this.$uuid();
  }
}
